import {
  getApp,
  getApps,
  initializeApp
} from "firebase/app";
import {
  connectAuthEmulator,
  getAuth
} from "firebase/auth";
import {
  connectFunctionsEmulator,
  getFunctions
} from "firebase/functions";

const config = {
  apiKey:
    import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain:
    import.meta.env
      .VITE_FIREBASE_AUTH_DOMAIN,
  projectId:
    import.meta.env
      .VITE_FIREBASE_PROJECT_ID,
  storageBucket:
    import.meta.env
      .VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId:
    import.meta.env
      .VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId:
    import.meta.env.VITE_FIREBASE_APP_ID
};

export const firebaseApp =
  getApps().length > 0
    ? getApp()
    : initializeApp(config);

export const auth =
  getAuth(firebaseApp);

export const functions = getFunctions(
  firebaseApp,
  import.meta.env
    .VITE_FUNCTIONS_REGION ||
    "northamerica-northeast1"
);

export const useFirebaseEmulators =
  import.meta.env
    .VITE_USE_FIREBASE_EMULATORS ===
  "true";

if (
  useFirebaseEmulators &&
  !(globalThis as Record<string, unknown>)
    .__CAMP_POINTS_CORE_EMULATORS_CONNECTED__
) {
  connectAuthEmulator(
    auth,
    "http://127.0.0.1:9099",
    {
      disableWarnings: true
    }
  );

  connectFunctionsEmulator(
    functions,
    "127.0.0.1",
    5001
  );

  (
    globalThis as Record<string, unknown>
  ).__CAMP_POINTS_CORE_EMULATORS_CONNECTED__ =
    true;
}
